import { FC } from 'react';

import { NotFoundLayout } from '../../layouts/NotFoundLayout';
import { NotFoundContent } from '../../components/NotFoundContent';

export const NotFoundPage: FC = () => {
    return (
        <NotFoundLayout>
            <NotFoundContent />
        </NotFoundLayout>
    );
};
